<template>
  <vs-popup class="create-sundry-supplier-popup"
            id="popup"
            title="VIEW/UPDATE SUNDRY ITEM"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateSundryItem)" autocomplete="off">

<!--          <div class="con-expand-users w-full">-->
<!--            <div class="con-btns-user flex items-center justify-between">-->
<!--              <div class="con-userx flex items-center justify-start">-->
<!--                <vs-chip transparent color="dark">-->
<!--                  {{createForm.status.name}}-->
<!--                </vs-chip>-->
<!--              </div>-->
<!--              <div class="flex">-->
<!--                <vx-tooltip class="ml-2" text="Approve" position="left">-->
<!--                  <vs-button @click="openStatusChangeConfirm('approve')"-->
<!--                             size="small" color="primary" type="border" icon-pack="feather" icon="icon-check">Approve</vs-button>-->
<!--                </vx-tooltip>-->
<!--                <vx-tooltip class="ml-2" text="Reject" position="left">-->
<!--                  <vs-button @click="openStatusChangeConfirm('reject')"-->
<!--                             size="small" color="danger" type="border" icon-pack="feather" icon="icon-x">Reject</vs-button>-->
<!--                </vx-tooltip>-->
<!--                <vx-tooltip class="ml-2" text="Not In Use" position="left">-->
<!--                  <vs-button @click="openStatusChangeConfirm('not_in_use')"-->
<!--                             size="small" color="danger" type="border" icon-pack="feather" icon="icon-circle">Not In Use</vs-button>-->
<!--                </vx-tooltip>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

          <div class="vx-row">
            <div class="vx-col">
              Supplier: <a class="cursor-pointer" @click.stop="onClickViewSupplier">{{ createForm.supplier_name }}</a>
            </div>
          </div>

          <div class="vx-row mb-3 mt-8">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sundry_product_code" name="sundry_product_code" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Code</small>
                <vs-input disabled v-model="createForm.sundry_product_code"   name="sundry_product_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sundry_product_name" name="sundry_product_name" rules="required" v-slot="{ errors }">
                <small class="label">Supplier Product Name</small>
                <vs-input disabled v-model="createForm.sundry_product_name"   name="sundry_product_name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country_manufacture" name="country_manufacture" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :filter-by="myFilter"  :clearable="false" name="country_manufacture" placeholder="" label="name" v-model="createForm.country_manufacture" :reduce="option => option.name" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} </span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sold_in" name="sold_in" rules="required" v-slot="{ errors }">
                <small class="label">Sold In</small>
                <v-select  :clearable="false" name="sold_in" placeholder="" v-model="createForm.sold_in" :reduce="option => option" :options="['kg', 'l', 'units']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="min_OQ" name="min_OQ" rules="required|moq:1" v-slot="{ errors }">
                <small class="label">Min Order Quantity</small>
                <vs-input type="number" step="1" v-model="createForm.min_OQ"   name="min_OQ" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="packaging_size" name="packaging_size" rules="" v-slot="{ errors }">
                <small class="label">Quantity In Each Pack/Box</small>
                <vs-input type="number" step="1" v-model="createForm.packaging_size"   name="packaging_size" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="unit_price" name="unit_price" rules="required|two_decimal" v-slot="{ errors }">
                <small class="label">Unit Price ({{ createForm.supplier_account_currency }})</small>
                <vs-input type="number" step="any" v-model="createForm.unit_price"   name="unit_price" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <small class="label">Shipping File (.doc, .jpg, .pdf, .jpeg, .png, .docx, .txt)</small>
                <file-uploader-not-required
                  v-on:onSetFileName="value => createForm.shipping_handling = value"
                  v-on:onClickFileRemove="createForm.shipping_handling = null"
                  :file="createForm.shipping_handling"
                  :condition="true"/>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="is_low_stock_threshold_required" name="is_low_stock_threshold_required" rules="" v-slot="{ errors }">
                <small class="label">Do you want to set a low stock level warning?</small>
                <vs-switch  v-model="createForm.is_low_stock_threshold_required" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="createForm.is_low_stock_threshold_required">
              <ValidationProvider vid="low_stock_threshold" name="low_stock_threshold" rules="required" v-slot="{ errors }">
                <small class="label">Threshold (KG)</small>
                <vs-input type="number" step="0.001" v-model="createForm.low_stock_threshold" name="low_stock_threshold" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <small class="label">Nominal Code</small>
              <v-select :clearable="false" name="nominal_code" placeholder=""
                        label="name" v-model="createForm.sage_nominal_code_id" :reduce="option => option.id"
                        :options="sage_nominal_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="description" name="description" rules="" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea  class="mb-0" v-model="createForm.description" />
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="additional_information" name="additional_information" rules="" v-slot="{ errors }">
                <small class="label">Additional Information</small>
                <vs-textarea  class="mb-0" v-model="createForm.additional_information" />
              </ValidationProvider>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'create-edit-sundry-suppliers'" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SundrySupplierRepository = RepositoryFactory.get('sundry')
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');

  function initialState() {
    return {
      open: false,
      createForm: {},
      countryCodes: [],
      id: '',
      sage_nominal_codes:[]
    }
  }

export default {
  name: 'UpdateSundryItemPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.id = id
        await this.loadCountrCode()
        await this.fetchSundryItemDetails()
        await this.getSageNominalCodes()
        this.open = true;
      } catch (error) {

      }
    },
    async loadCountrCode() {
      this.$vs.loading()
      const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
      this.countryCodes =  data
      this.$vs.loading.close()
    },
    async fetchSundryItemDetails() {
      this.$vs.loading()
      const {data} =  (await SundrySupplierRepository.getSundryItemDetails(this.id)).data
      this.createForm =  data
      this.createForm.sage_nominal_code_id = data.sage_nominal_code.id
      this.$vs.loading.close()
    },
    async getSageNominalCodes(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
      this.sage_nominal_codes =  data.data
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async onClickCreateSundryItem () {
      const vue = this;
      this.$vs.loading()
       try {
         let payload = Object.assign({}, this.createForm)
         if(!payload.is_low_stock_threshold_required) {
            delete payload.low_stock_threshold
          } else {
            payload.low_stock_threshold = Number(payload.low_stock_threshold).toFixed(4)
          }
         payload.unit_price = Number(payload.unit_price).toFixed(2)
         await SundrySupplierRepository.updateSundryItem(this.id, payload)
         this.showSuccessMessage('Sundry item updated successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    sundryItemStatusColorFactory(id) {
      switch (id) {
        case 1:
          return 'warning';
        case 2:
          return 'primary';
        case 3:
          return 'danger';
        case 4:
          return 'warning';
      }
    },
    openStatusChangeConfirm (status) {
      this.open = false
      this.$vs.dialog({
        type: 'confirm',
        color: status === 'approve' ? 'success' : 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to make this change?',
        accept: this.changeSundryItemStatus,
        parameters: [status]
      })
    },
    async changeSundryItemStatus (params) {
      this.$vs.loading()
      try {
        await SundrySuppliersRepository.sundryItemStatusChange(this.id, params[0])
        this.showSuccessMessage('Sundry item status updated!')
        this.open = true
        await this.fetchSundryItemDetails()
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    onClickViewSupplier() {
      this.open = false
      this.$router.push(`/pages/manage-nimble/suppliers/sundry/${this.createForm.supplier_id}`)
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .create-sundry-supplier-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
</style>
